
import { Vue } from "vue-class-component"; // 基本需要
import {
  dispatchGetModelList,
  dispatchGetModelOptions,
  dispatchGetModelEdit,
  dispatchGetModelCreate,
  dispatchGetModelStatus,
} from "@/store/project/actions";
import { dispatchUploadModelUpload } from "@/store/performance/actions";
import { ElMessage } from "element-plus";
import * as echarts from "echarts";
import {
  readAdminProjects,
  readMyProjects,
  readProjectDetail,
} from "@/store/project/getters";
import {
  dispatchUploadGamesReportImage,
  dispatchDeleteDeviceModel,
} from "@/store/performance/actions";
import { readUserProfile } from "@/store/main/getters";
import { readModelList, readModelOptions } from "@/store/project/getters";
import { dateConversion } from "@/utils"; //类型
import { store } from "@/store";
import { getLocalProject } from "@/utils";
import "@/assets/iconfont/font_3410179_4ge8dortgia/iconfont.css"; //引入仓库
export default class GamesNew extends Vue {
  public localProject = 34;
  public ManagementData = {
    search: "",
    oem: "",
    cpu_name: "",
    ram: "",
    gpu: "",
    borrower: "",
    page: 1,
    size: 50,
  };
  public fileList = [];
  public beforeRemove(file) {
    let index_num = 0;
    this.fileList.forEach((v, index) => {
      if (v.uid == file.uid) {
        index_num = index;
      }
    });
    this.fileList.splice(index_num, 1);
  }
  public dialogVisible = false;
  public async peloadChange_top(type) {
    if (type) {
      this.ManagementData.page = 1;
    }
    await dispatchGetModelList(store, {
      search: this.ManagementData.search,
      oem: this.ManagementData.oem,
      cpu_name: this.ManagementData.cpu_name,
      ram: this.ManagementData.ram,
      borrower: this.ManagementData.borrower,
      page: this.ManagementData.page,
      size: this.ManagementData.size,
      gpu: this.ManagementData.gpu,
    });
  }
  public upData() {
    this.dialogVisible = true;
  }
  public addBtn() {
    this.dialogFormVisible = true;
    this.add = JSON.parse(JSON.stringify(this.addCreate));
  }
  public many_click() {
    this.many = !this.many;
    this.ManagementData.gpu = "";
    this.ManagementData.borrower = "";
  }
  public id = 0;
  public dialogFormVisible1 = false;
  public statusBtn(id) {
    this.id = id;
    this.time = new Date();
    this.dialogFormVisible1 = true;
  }
  public async deleteBtn(id) {
    await dispatchDeleteDeviceModel(store, {
      project: this.localProject,
      id: id,
    });
    await dispatchGetModelList(store, {
      search: this.ManagementData.search,
      oem: this.ManagementData.oem,
      cpu_name: this.ManagementData.cpu_name,
      ram: this.ManagementData.ram,
      borrower: this.ManagementData.borrower,
      page: this.ManagementData.page,
      size: this.ManagementData.size,
      gpu: this.ManagementData.gpu,
    });
  }
  public many = false;
  public async editDay(id, type) {
    await dispatchGetModelStatus(store, {
      status: type,
      id: id,
      return_time: type == 1 ? dateConversion(this.time) : null,
    });

    this.dialogFormVisible1 = false;
    await dispatchGetModelList(store, {
      search: this.ManagementData.search,
      oem: this.ManagementData.oem,
      cpu_name: this.ManagementData.cpu_name,
      ram: this.ManagementData.ram,
      borrower: this.ManagementData.borrower,
      page: this.ManagementData.page,
      size: this.ManagementData.size,
      gpu: this.ManagementData.gpu,
    });
  }
  public time = new Date();
  public name(i) {
    if (i == "name") {
      return "设备名";
    }
    if (i == "model") {
      return "型号";
    }
    if (i == "heroname") {
      return "英雄名";
    }
    if (i == "skin") {
      return "皮肤序号";
    }
    if (i == "skinname") {
      return "皮肤名";
    }
  }
  public async edit() {
    let list = [];
    let indexList = ["name", "model"];
    indexList.forEach((v) => {
      if (!this.add[v]) {
        list.push(v);
      }
    });
    let str = "";
    if (list.length > 0) {
      list.forEach((i, index) => {
        str += this.name(i) + (index == list.length - 1 ? "" : ",");
      });
      alert(str + "不能为空");
      return;
    }
    let b = (this as any).$message({
      //Message 消息提示
      message: "创建中",
      showClose: true,
      duration: 0,
    });
    await dispatchGetModelCreate(store, this.add);
    b.close();
    ElMessage.success({
      message: "创建成功",
      showClose: true,
      type: "success",
    });
    this.dialogFormVisible = false;
    dispatchGetModelOptions(store, {
      project: this.localProject,
    });
    dispatchGetModelList(store, {
      search: this.ManagementData.search,
      oem: this.ManagementData.oem,
      cpu_name: this.ManagementData.cpu_name,
      ram: this.ManagementData.ram,
      borrower: this.ManagementData.borrower,
      page: this.ManagementData.page,
      size: this.ManagementData.size,
      gpu: this.ManagementData.gpu,
    });
  }
  public async UploadFile(param: any, file) {
    this.fileList.push(param.file);
    // this.formData.append('file',)
  }
  public deviceType = ["Android", "iOS"];
  public sys = ["国内", "海外"];
  public add = {
    name: null,

    oem: null,
    model: null,
    cpu_name: null,
    cpu_model: null,
    gpu_model: null,
    gpu_name: null,
    resolution: null,
    ram: null,
    asset_number: null, // 资产编号
    core_num: null, // 核心数
    screen_refresh_rate: null,
    os: null,
    cpu_digit: null,
    cpu_frequency: null,
    type: 0, // 0:Android, 1:iOS
    area: 0, // 0:国内, 1:海外
  };
  public addCreate = {
    name: null,

    oem: null,
    model: null,
    cpu_name: null,
    cpu_model: null,
    gpu_model: null,
    gpu_name: null,
    resolution: null,
    ram: null,
    asset_number: null, // 资产编号
    core_num: null, // 核心数
    screen_refresh_rate: null,
    os: null,
    cpu_digit: null,
    cpu_frequency: null,
    type: 0, // 0:Android, 1:iOS
    area: 0, // 0:国内, 1:海外
  };
  public handleChange() {
    this.dialogFormVisible2 = false;
    const allLists = [
      ...this.checkList_others,
      ...this.checkList_parameters,
      ...this.checkList_device,
    ];

    // 删除all_check中不存在于allLists中的字段
    this.all_check = this.all_check.filter((item) => allLists.includes(item));

    // 将allLists中不存在于all_check中的字段添加到all_check中
    allLists.forEach((item) => {
      if (!this.all_check.includes(item)) {
        this.all_check.push(item);
      }
    });
  }
  public dialogForm = false;
  public dialogFormVisible = false;
  public get device_properties() {
    let device_properties = [
      { name: "asset_number", chinese_name: "资产编号", value: false },

      { name: "area", chinese_name: "地区", value: false },
      { name: "status", chinese_name: "设备状态", value: false },
    ];
    return device_properties;
  }
  public chinese(data) {
    const combinedArray = [
      ...this.hardware_parameters,
      ...this.other_info,
      ...this.device_properties,
    ];
    const item = combinedArray.find((item) => item.name === data);
    if (item) {
      return item.chinese_name;
    } else {
      return null;
    }
  }
  public checkList_device = ["status"];
  public checkList_parameters = [
    "name",
    "oem",
    "model",
    "score",
    "cpu_name",
    "cpu_model",
    "gpu_name",
    "gpu_model",
    "resolution",
    "ram",
  ];
  public checkList_others = ["borrower"];
  public get hardware_parameters() {
    let hardware_parameters = [
      { name: "name", chinese_name: "设备名称", value: false },
      { name: "type", chinese_name: "设备类型", value: false },
      { name: "oem", chinese_name: "品牌", value: false },
      { name: "model", chinese_name: "设备型号", value: false },
      { name: "score", chinese_name: "综合评分", value: false },
      { name: "cpu_name", chinese_name: "CPU名", value: false },
      { name: "cpu_model", chinese_name: "CPU型号", value: false },
      { name: "gpu_model", chinese_name: "GPU型号", value: false },
      { name: "gpu_name", chinese_name: "GPU名", value: false },
      { name: "resolution", chinese_name: "分辨率", value: false },
      { name: "ram", chinese_name: "RAM(内存)", value: false },
      { name: "core_num", chinese_name: "核心数", value: false },
      { name: "screen_refresh_rate", chinese_name: "屏幕刷新率", value: false },
      { name: "os", chinese_name: "系统版本", value: false },
      { name: "cpu_digit", chinese_name: "CPU位数", value: false },
      { name: "cpu_frequency", chinese_name: "CPU频率", value: false },
    ];
    return hardware_parameters;
  }
  public get other_info() {
    let other_info = [
      { name: "borrower", chinese_name: "当前借用人", value: false },
      { name: "return_time", chinese_name: "归还时间", value: false },
      // Add any other fields here as needed
    ];
    return other_info;
  }
  public dis_check = ["borrower", "status", "return_time", "type", "area"];

  public empty() {
    this.ManagementData.search = "";
    this.ManagementData.oem = "";
    this.ManagementData.cpu_name = "";
    this.ManagementData.ram = "";
    this.ManagementData.borrower = "";
    this.ManagementData.page = 1;
    this.ManagementData.size = 50;

    dispatchGetModelList(store, {
      search: this.ManagementData.search,
      oem: this.ManagementData.oem,
      cpu_name: this.ManagementData.cpu_name,
      ram: this.ManagementData.ram,
      borrower: this.ManagementData.borrower,
      page: this.ManagementData.page,
      size: this.ManagementData.size,
      gpu: this.ManagementData.gpu,
    });
  }
  public get managementList() {
    return readModelList(store);
  }
  public get managementOptions() {
    return readModelOptions(store);
  }
  public get name_img() {
    return readUserProfile(store).username;
  }

  public handleDeleteScene(data) {
    data.modify = false;
    dispatchGetModelEdit(store, {
      id: data.id,
      name: data.name,
      score: data.score,
      oem: data.oem,
      model: data.model,
      cpu_name: data.cpu_name,
      cpu_model: data.cpu_model,
      gpu_model: data.gpu_model,
      gpu_name: data.gpu_name,
      resolution: data.resolution,
      ram: data.ram,
      asset_number: data.asset_number, // 资产编号
      core_num: data.core_num, // 核心数
      screen_refresh_rate: data.screen_refresh_rate,
      os: data.os,
      cpu_digit: data.cpu_digit,
      cpu_frequency: data.cpu_frequency,
      type: data.type, // 0:Android, 1:iOS
      area: data.area, // 0:国内, 1:海外
    });
  }
  public formData: any = new FormData();
  public async submitUpload(btn: string) {
    if (btn === "no") {
      this.formData = new FormData();
      (this.$refs["upload"] as any)?.clearFiles();
    }
    if (btn === "ok") {
      this.formData.append("project", this.localProject);
      this.fileList.forEach((item, index) => {
        this.formData.append("file", item);
      });

      this.dialogVisible = false;

      let b = (this as any).$message({
        //Message 消息提示
        message: "上传中",
        showClose: true,
        duration: 0,
      });
      await dispatchUploadModelUpload(store, this.formData);

      b.close();
      ElMessage.success({
        message: "数据上传成功",
        showClose: true,
        type: "success",
      });
      this.formData = new FormData();
      this.fileList = [];
      (this.$refs["upload"] as any)?.clearFiles();
      this.empty();
    }
  }
  public serch() {
    dispatchGetModelList(store, {
      search: this.ManagementData.search,
      oem: this.ManagementData.oem,
      cpu_name: this.ManagementData.cpu_name,
      ram: this.ManagementData.ram,
      borrower: this.ManagementData.borrower,
      page: this.ManagementData.page,
      size: this.ManagementData.size,
      gpu: this.ManagementData.gpu,
    });
  }
  public dialogFormVisible2 = false;
  public all_check = [];
  public mounted() {
    this.checkList_parameters.forEach((v) => {
      this.all_check.push(v);
    });
    this.checkList_device.forEach((v) => {
      this.all_check.push(v);
    });
    this.checkList_others.forEach((v) => {
      this.all_check.push(v);
    });
    console.log(this.all_check);
    dispatchGetModelOptions(store, {
      project: this.localProject,
    });
    dispatchGetModelList(store, {
      search: this.ManagementData.search,
      oem: this.ManagementData.oem,
      cpu_name: this.ManagementData.cpu_name,
      ram: this.ManagementData.ram,
      borrower: this.ManagementData.borrower,
      page: this.ManagementData.page,
      size: this.ManagementData.size,
      gpu: this.ManagementData.gpu,
    });
  }
}
